import { render, staticRenderFns } from "./CmgCheckoutCustomerPayment.vue?vue&type=template&id=0673f001&scoped=true&lang=pug&"
import script from "./cmg-checkout-customer-payment.ts?vue&type=script&lang=ts&"
export * from "./cmg-checkout-customer-payment.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCheckoutCustomerPayment.vue?vue&type=style&index=0&id=0673f001&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0673f001",
  null
  
)

export default component.exports